<rt-dialog-header
  [heading]="'tlc.positions.skills_ideate_flow.options.heading' | translate"
  [subheading]="'tlc.positions.skills_ideate_flow.options.subheading' | translate"
/>

<rt-dialog-body variant="white">
  <img
    class="success-illustration"
    ngSrc="assets/images/tellent-skills/xlsx-success.svg"
    alt=""
    [width]="104"
    [height]="101"
  />
  <div class="text-container">
    <rt-heading variant="heading" class="heading">
      {{ 'tlc.positions.skills_ideate_flow.result.success.heading' | translate }}
    </rt-heading>
    <span class="description">{{
      'tlc.positions.skills_ideate_flow.result.success.description'
        | translate: { count: skillsCount() }
    }}</span>
  </div>
  <rt-button variant="primary" [loading]="isDownloading()" (click)="downloadFile()">
    <rt-icon name="file-download" />
    <span>{{ 'tlc.positions.skills_ideate_flow.result.success.download_file' | translate }}</span>
  </rt-button>
</rt-dialog-body>

<rt-dialog-footer [hasOptionalActions]="true" innerPadding="small">
  <div class="optional">
    <rt-button variant="plain" (click)="backToStart()">
      <rt-icon name="arrow-back" />
      <span>{{ 'tlc.positions.skills_ideate_flow.result.success.back_to_start' | translate }}</span>
    </rt-button>
  </div>
  <rt-button variant="plain" (click)="close()">
    <rt-icon name="check" />
    <span>{{
      'tlc.positions.skills_ideate_flow.result.success.finish_and_close' | translate
    }}</span>
  </rt-button>
</rt-dialog-footer>
